import React from 'react';
import classNames from 'classnames';
import { StatisticsValueType } from 'twain-sport-fe-mono/enums';
import { TwainGameId } from 'betgames-contract-js';
import { EMPTY_SPACE } from 'twain-sport-fe-mono/constants/textSymbols';
import { formatStatisticsValue } from 'twain-sport-fe-mono/utils/formatStatisticsValue';
import { IParticipantDetailedStatistics } from 'twain-sport-fe-mono/interfaces';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { StatisticRowSkeleton } from '../ParticipantProfileStatisticsSkeleton';
import classes from './StatisticItem.module.scss';

const translations: Record<string, string> = {
    winningPercentage: 'winning_percentage',
    pointsPerGame: 'points_per_game',
    accuracy: 'accuracy',
    shotsPerGame: 'shots_per_game',
};

interface IProps extends Partial<IParticipantDetailedStatistics> {
    pending?: boolean;
    gameId?: TwainGameId;
    columnView?: boolean;
}

export const StatisticItem: React.FC<IProps> = (props) => {
    const t = translationProvider;
    const isPercentage = props.type === StatisticsValueType.PERCENTAGE;

    return (
        <div
            className={classNames(classes.statisticContainer, {
                [classes.columnView]: props.columnView,
            })}
        >
            <div className={classes.row}>
                {props.pending ? (
                    <StatisticRowSkeleton />
                ) : (
                    <>
                        <p className={classes.name}>
                            {t.stringByGame(translations[props.name] || props.name, props.gameId)}
                        </p>
                        <b>
                            {formatStatisticsValue(props)}
                            {isPercentage ? '%' : ''}
                        </b>
                    </>
                )}
            </div>
            <div className={classes.row}>
                {props.pending ? (
                    <StatisticRowSkeleton />
                ) : (
                    <>
                        <p>
                            {t.string('rank')}
                            {EMPTY_SPACE}#{props.rank}
                        </p>
                        <p>
                            {t.string('leader')}
                            {EMPTY_SPACE}
                            {formatStatisticsValue({ value: props.bestValue, type: props.type })}
                            {isPercentage ? '%' : ''}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};
